/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Usermanagement_Permissions_Seemore2Inputs */

const en_usermanagement_permissions_seemore2 = /** @type {(inputs: Usermanagement_Permissions_Seemore2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`See more permissions (${i?.count})`)
};

/**
* | output |
* | --- |
* | "See more permissions ({count})" |
*
* @param {Usermanagement_Permissions_Seemore2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_seemore2 = /** @type {((inputs: Usermanagement_Permissions_Seemore2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Seemore2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_seemore2(inputs)
});
export { usermanagement_permissions_seemore2 as "userManagement_permissions_seeMore" }